// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as ReactDom from "react-dom";
import * as IconButton from "../actions/IconButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  footerSecondaryActions: {
    "marginLeft-koQZXg": "marginLeft-x8x9d4c",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:26"
  }
};
function footerViewStyleFromParams(variation) {
  return {
    0: {
      className: "backgroundColor-x17suf5r borderTopColor-x1eit1tb borderTopStyle-x13fuv20 borderTopWidth-x178xt8z position-x1n2onr6 zIndex-xhtitgo",
      "data-style-src": "wino-gc:src/resources/overlays/Modal.res.js:18"
    },
    1: {}
  }[!!(variation === "primary") << 0];
}
function Modal$ModalFooter(props) {
  let __onRequestClose = props.onRequestClose;
  let __closeOnCommit = props.closeOnCommit;
  let __commitButtonPending = props.commitButtonPending;
  let commitButtonCallback = props.commitButtonCallback;
  let commitButtonIcon = props.commitButtonIcon;
  let commitButtonText = props.commitButtonText;
  let commitButtonTone = props.commitButtonTone;
  let __allowCommit = props.allowCommit;
  let abortButtonText = props.abortButtonText;
  let criticalButtonCallback = props.criticalButtonCallback;
  let criticalButtonText = props.criticalButtonText;
  let __renderStartText = props.renderStartText;
  let variation = props.variation;
  let renderStartText = __renderStartText !== undefined ? __renderStartText : () => null;
  let allowCommit = __allowCommit !== undefined ? __allowCommit : true;
  let commitButtonPending = __commitButtonPending !== undefined ? __commitButtonPending : false;
  let closeOnCommit = __closeOnCommit !== undefined ? __closeOnCommit : true;
  let onRequestClose = __onRequestClose !== undefined ? __onRequestClose : () => {};
  let newrecord = {
    ...footerViewStyleFromParams(variation)
  };
  return JsxRuntime.jsx("div", (newrecord.children = variation === "primary" ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Button.make, {
        label: commitButtonText !== undefined && commitButtonCallback !== undefined ? I18n.t("Cancel") : I18n.t("Close"),
        onPress: () => onRequestClose()
      }), commitButtonText !== undefined && commitButtonCallback !== undefined ? JsxRuntime.jsx(Button.make, {
        label: commitButtonText,
        variant: "solid",
        tone: commitButtonTone,
        disabled: !allowCommit,
        pending: commitButtonPending,
        icon: commitButtonIcon,
        onPress: () => {
          if (closeOnCommit) {
            onRequestClose();
          }
          commitButtonCallback();
        }
      }) : null],
      space: "normal",
      align: "end"
    }),
    spaceX: "large",
    spaceTop: "xsmall",
    spaceBottom: "xlarge"
  }) : JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [renderStartText(), JsxRuntime.jsxs(Inline.make, {
        children: [criticalButtonText !== undefined && criticalButtonCallback !== undefined ? JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Button.make, {
            label: criticalButtonText,
            variant: "solid",
            tone: "danger",
            onPress: () => {
              onRequestClose();
              criticalButtonCallback();
            }
          })
        }) : null, abortButtonText !== undefined ? JsxRuntime.jsx(Button.make, {
          label: abortButtonText,
          onPress: () => onRequestClose()
        }) : null, commitButtonText !== undefined && commitButtonCallback !== undefined ? JsxRuntime.jsx(Button.make, {
          label: commitButtonText,
          variant: "solid",
          tone: commitButtonTone,
          disabled: !allowCommit,
          pending: commitButtonPending,
          icon: commitButtonIcon,
          onPress: () => {
            if (closeOnCommit) {
              onRequestClose();
            }
            commitButtonCallback();
          }
        }) : null],
        space: "small",
        stylex: Primitive_option.some(styles.footerSecondaryActions)
      })],
      align: "spaceBetween"
    }),
    spaceX: "large",
    spaceY: "small"
  }), newrecord));
}
let make = React.memo(Modal$ModalFooter);
let styles$1 = {
  wrapper: {
    "backgroundColor-kWkggS": "backgroundColor-xjbqb8w",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "bottom-krVfgx": "bottom-x1ey2m1c",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "left-kbCHJM": "left-xu96u03",
    "position-kVAEAm": "position-xixxii4",
    "right-kCIrl2": "right-x3m8u43",
    "top-k87sOh": "top-x13vifvy",
    "zIndex-kY2c9j": "zIndex-x11uqc5h",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:138"
  },
  backdrop: {
    "backdropFilter-k6WDB": "backdropFilter-xc6kmox",
    "backgroundColor-kWkggS": "backgroundColor-x1xwfbwq",
    "cursor-kkrTdU": "cursor-x1sqbtui",
    "opacity-kSiTet": "opacity-xg01cxk",
    "height-kZKoxP": "height-x1dr59a3",
    "width-kzqmXN": "width-xn9wirt",
    "zIndex-kY2c9j": "zIndex-x1ja2u2z",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:150"
  },
  inner: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "boxShadow-kGVxlE": "boxShadow-x1o15m8c",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "maxHeight-kskxy": "maxHeight-xdnzh0y",
    "maxWidth-ks0D6T": "maxWidth-xh9uqaf",
    "minHeight-kAzted": "minHeight-x1hvupsl",
    "minWidth-k7Eaqz": "minWidth-xp9ttsr",
    "overflow-kVQacm": "overflow-xb3r6kr",
    "position-kVAEAm": "position-x10l6tqk",
    "zIndex-kY2c9j": "zIndex-x1vjfegm",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:159"
  },
  body: {
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "minHeight-kAzted": "minHeight-x2lwn1j",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:173"
  },
  wrapperViewOpened: {
    "transition-kmkexE": "transition-x1hl07er",
    "zIndex-kY2c9j": "zIndex-x1fina04",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:190"
  },
  wrapperViewClosed: {
    "transition-kmkexE": "transition-x1hl07er",
    "zIndex-kY2c9j": "zIndex-x8knxv4",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:194"
  },
  backdropViewOpened: {
    "opacity-kSiTet": "opacity-x18km98s",
    "transition-kmkexE": "transition-x1hl07er",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:198"
  },
  backdropViewClosed: {
    "opacity-kSiTet": "opacity-xg01cxk",
    "transition-kmkexE": "transition-x1hl07er",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:202"
  },
  innerViewOpened: {
    "opacity-kSiTet": "opacity-x1hc1fzr",
    "transition-kmkexE": "transition-x187a29u",
    "transform-k3aq6I": "transform-xds7yc5",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:206"
  },
  innerViewClosed: {
    "opacity-kSiTet": "opacity-xg01cxk",
    "transition-kmkexE": "transition-xlpjoa7",
    "transform-k3aq6I": "transform-xse5ao4",
    $$css: "wino-gc:src/resources/overlays/Modal.res.js:211"
  }
};
function wrapperViewStyleFromParams(opened) {
  if (opened) {
    return styles$1.wrapperViewOpened;
  } else {
    return styles$1.wrapperViewClosed;
  }
}
function backdropViewStyleFromParams(opened) {
  if (opened) {
    return styles$1.backdropViewOpened;
  } else {
    return styles$1.backdropViewClosed;
  }
}
function innerViewStyleFromParams(opened, compact, width) {
  return Stylex.props(styles$1.inner, opened ? styles$1.innerViewOpened : styles$1.innerViewClosed, compact ? {} : {
    width: "60%"
  }, width !== undefined ? {
    maxWidth: "90%",
    minWidth: "min-content",
    width: width
  } : {});
}
function bodyViewStyleFromParams(backgroundColor) {
  return {
    backgroundColor: backgroundColor
  };
}
function Modal(props) {
  let onRequestClose = props.onRequestClose;
  let __closeOnCommit = props.closeOnCommit;
  let __commitButtonPending = props.commitButtonPending;
  let commitButtonCallback = props.commitButtonCallback;
  let __commitButtonTone = props.commitButtonTone;
  let __allowCommit = props.allowCommit;
  let __renderStartText = props.renderStartText;
  let __hideFooter = props.hideFooter;
  let __backgroundColor = props.backgroundColor;
  let __compact = props.compact;
  let __variation = props.variation;
  let opened = props.opened;
  let variation = __variation !== undefined ? __variation : "primary";
  let compact = __compact !== undefined ? __compact : true;
  let backgroundColor = __backgroundColor !== undefined ? __backgroundColor : "#f8f8fb";
  let hideFooter = __hideFooter !== undefined ? __hideFooter : false;
  let renderStartText = __renderStartText !== undefined ? __renderStartText : () => null;
  let allowCommit = __allowCommit !== undefined ? __allowCommit : true;
  let commitButtonTone = __commitButtonTone !== undefined ? __commitButtonTone : "success";
  let commitButtonPending = __commitButtonPending !== undefined ? __commitButtonPending : false;
  let closeOnCommit = __closeOnCommit !== undefined ? __closeOnCommit : true;
  let match = React.useState(() => Primitive_option.fromNullable(document.querySelector("#portals-modal")));
  let setModalRoute = match[1];
  let modalRoot = match[0];
  let match$1 = {
    className: "height-x5yr21d overflow-xysyzu8",
    "data-style-src": "wino-gc:src/resources/overlays/Modal.res.js:186"
  };
  React.useEffect(() => {
    let match = document.querySelector("body");
    if (modalRoot === undefined && !(match == null)) {
      let element = document.createElement("div");
      element.setAttribute("id", "portals-modal");
      setModalRoute(param => Primitive_option.some(element));
      match.appendChild(element);
    }
    let handler = evt => {
      let ctrlKeyPressed = evt.ctrlKey;
      let match = evt.key;
      switch (match) {
        case "Enter":
          if (ctrlKeyPressed) {
            Stdlib_Option.forEach(commitButtonCallback, commit => commit());
            if (closeOnCommit) {
              return Stdlib_Option.forEach(onRequestClose, close => close());
            } else {
              return;
            }
          } else {
            return;
          }
        case "Escape":
          return Stdlib_Option.forEach(onRequestClose, fn => fn());
        default:
          return;
      }
    };
    let domDocument = document;
    if (opened) {
      domDocument.addEventListener("keydown", handler);
    } else {
      domDocument.removeEventListener("keydown", handler);
    }
    return () => {
      domDocument.removeEventListener("keydown", handler);
    };
  }, [modalRoot, commitButtonCallback, closeOnCommit]);
  if (modalRoot === undefined) {
    return null;
  }
  if (!opened) {
    return null;
  }
  let newrecord = {
    ...Stylex.props(styles$1.wrapper, wrapperViewStyleFromParams(opened))
  };
  let newrecord$1 = {
    ...innerViewStyleFromParams(opened, compact, props.width)
  };
  let newrecord$2 = {
    ...{
      className: "borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xlxy82",
      "data-style-src": "wino-gc:src/resources/overlays/Modal.res.js:133"
    }
  };
  let newrecord$3 = {
    ...Stylex.props(styles$1.body, bodyViewStyleFromParams(backgroundColor))
  };
  let newrecord$4 = {
    ...{
      className: "flex-x98rzlu minHeight-x2lwn1j overflow-xysyzu8 position-x1n2onr6",
      "data-style-src": "wino-gc:src/resources/overlays/Modal.res.js:180"
    }
  };
  newrecord$3.children = [JsxRuntime.jsx("div", (newrecord$4.children = JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Box.make, {
      children: props.children,
      grow: true
    }),
    className: match$1.className,
    style: match$1.style
  }), newrecord$4)), hideFooter ? null : JsxRuntime.jsx(make, {
    variation: variation,
    renderStartText: renderStartText,
    criticalButtonText: props.criticalButtonText,
    criticalButtonCallback: props.criticalButtonCallback,
    abortButtonText: props.abortButtonText,
    allowCommit: allowCommit,
    commitButtonTone: commitButtonTone,
    commitButtonText: props.commitButtonText,
    commitButtonIcon: props.commitButtonIcon,
    commitButtonCallback: commitButtonCallback,
    commitButtonPending: commitButtonPending,
    closeOnCommit: closeOnCommit,
    onRequestClose: onRequestClose
  })];
  newrecord$1.children = [JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Title.make, {
        children: props.title,
        level: 3,
        weight: "medium"
      }), onRequestClose !== undefined ? JsxRuntime.jsx(IconButton.make, {
        name: "close_bold",
        color: "#a2a1b0",
        hoveredColor: "#797885",
        onPress: param => onRequestClose()
      }) : null],
      align: "spaceBetween",
      grow: true
    }),
    spaceX: "large",
    spaceY: "large"
  }), newrecord$2)), JsxRuntime.jsxs("div", newrecord$3)];
  newrecord.children = [JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx("div", Stylex.props(styles$1.backdrop, backdropViewStyleFromParams(opened))),
    onPress: param => Stdlib_Option.forEach(onRequestClose, fn => fn())
  }), JsxRuntime.jsxs("div", newrecord$1)];
  return ReactDom.createPortal(JsxRuntime.jsxs("div", newrecord), Primitive_option.valFromOption(modalRoot));
}
let make$1 = React.memo(Modal);
export { make$1 as make };
/* styles Not a pure module */